import React from "react";
import { Input } from "../../../../../../components";
import { FORM_KEYS } from "../../../../constants";

/**
 * @desc Input SKU for add product form.
 */
export const InputSKU = (props) => {
  // CONSTANTS ----------------------------------------------------------------

  const errorProps = {
    id: "form-sku-error",
  };

  const inputProps = {
    type: "text",
    id: "input-sku",
    className: "form-control convention-input",
    "aria-describedby": errorProps.id,
    autoComplete: "off",
    ...props,
  };

  const labelProps = {
    className: "form-control-label",
    htmlFor: inputProps.id,
    children: "Product SKU",
  };

  // COMPONENT ----------------------------------------------------------------

  const parentProps = {
    inputProps,
    labelProps,
    errorProps,
    fieldName: FORM_KEYS.ADD_PRODUCT_SKU,
  };

  return <Input {...parentProps} />;
};

export default InputSKU;
